
export { loading } from "../ts/commons/loading";
export { Util as util } from "../ts/commons/util";
export * as dialog from "../ts/commons/dialog";
export { _SPA as SPA } from "../ts/commons/spa";

export * as components from "../ts/commons/components/components";

export { Notify as notify, notifyOptions } from "../ts/commons/notify";

//import { ModalBase } from "../ts/commons/base/modalBase";
//import { PageBase } from "../ts/commons/base/pageBase";
//import { SpreadBase } from "../ts/commons/base/spreadBase";
//export const base = { ModalBase, PageBase, SpreadBase };

export * as base from "../ts/commons/base/base";

//import { WorkBookBase } from "./commons/spread/workbookBase";
//import { WorkSheetBase } from "./commons/spread/workSheetBase";
//import { BlankSheet } from "./commons/spread/BlankSheet";
//export const spread = { WorkBookBase, WorkSheetBase, BlankSheet };

//************************************************************
//export class PlantGroupInfoGrid extends SPIRIT.spread.WorkBookBase {←これOK
//    sheet SPIRIT.spread.WorkSheetBase　　　　　　　　　　　　　　　←これNG
//************************************************************
//下記のようにしないと駄目みたい(Classのextendsには使用できるが、変数の型では使用できない)
export * as spread from "../ts/commons/spread/spread";

//export * as business from "../ts/commons/business";
export { Business as business } from "../ts/commons/business";

//export * as session from "../ts/commons/session";
export { Session as session } from "../ts/commons/session";
//#2599
export { Project as project } from "../ts/commons/project";

export * as codes from "./commons/define/codes";
export * as constant from "./commons/define/constant";
export * as interfaces from "./commons/define/interfaces";
export * as message from "./commons/define/message";

export { _AutoFit as autoFit } from "../ts/commons/autoFit";

/** siteのインスタンス */
export const navi = {
    instance: function () { return $(document).data('site'); },
    rebuild: function (): Promise<any> {
        return navi.instance()?.naviManager.rebuild();
    }
};


//import * as codes from "./commons/define/codes";
//import * as constant from "./commons/define/constant";
//export const  define = { codeValues, constant } ;



//下記はdeprecated!!
//export const views = {};
//export const global = this;
//export const enumerables = ['hasOwnProperty', 'valueOf', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'constructor'];

///**
// * 
// * @param {any} object
// * @param {any} config
// * @param {any} defaults
// * @deprecated
// */
//export function apply(object, config, defaults) {
//    if (object && config && typeof config === 'object') {
//        let i, j, k;
//        for (i in config) {
//            object[i] = config[i];
//        }
//        if (enumerables) {
//            for (j = enumerables.length; j--;) {
//                k = enumerables[j];
//                if (config.hasOwnProperty(k)) {
//                    object[k] = config[k];
//                }
//            }
//        }
//    }
//    return object;
//}

///**
// * 
// * @param {any} ns_string
// * @deprecated
// */
//export function namespace(ns_string) {


//    let parts = ns_string.split('.'), parent = SPIRIT, i;

//    if (parts[0] === 'SPIRIT') {
//        parts = parts.slice(1);
//    }

//    for (i = 0; i < parts.length; i += 1) {
//        if (typeof parent[parts[i]] === 'undefined') {
//            parent[parts[i]] = {};
//        }
//        parent = parent[parts[i]];
//    }
//    return parent;
//}






// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.





// Write your JavaScript code.
//import { loading } from "../ts/commons/loading";
//import Util from "../ts/commons/util";
//import *  as Dialog from "../ts/commons/dialog";
//import { Notify, notifyOptions } from "../ts/commons/notify";
//import { ModalBase } from "../ts/commons/base/modalBase";
//import { PageBase } from "../ts/commons/base/pageBase";

//import Business from "../ts/commons/business";
//import Session from "../ts/commons/session";
//import * as Codes from "./commons/define/codes";
//import * as Enums from "./commons/define/enums";



///**********************************************************************************
// * private
// **********************************************************************************/

//let global = this;

//const enumerables = [
//    'hasOwnProperty',
//    'valueOf',
//    'isPrototypeOf',
//    'propertyIsEnumerable',
//    'toLocaleString',
//    'toString',
//    'constructor'
//];



////$(document).ajaxStart(function () {
////});
////$(document).ajaxComplete(function () {
////});

////==============================================================================================================
//// プロジェクトnamespace定義
////==============================================================================================================
//export const SPIRIT = {
//    views: {},
//    global: global,
//    enumerables: enumerables,


//    /**
//     * 
//     * @param {any} object
//     * @param {any} config
//     * @param {any} defaults
//     * @deprecated
//     */
//    apply: function (object, config, defaults) {

//        //if (defaults) {
//        //    SPIRIT.apply(object, defaults);
//        //}

//        if (object && config && typeof config === 'object') {
//            let i, j, k;
//            for (i in config) {
//                object[i] = config[i];
//            }
//            if (enumerables) {
//                for (j = enumerables.length; j--;) {
//                    k = enumerables[j];
//                    if (config.hasOwnProperty(k)) {
//                        object[k] = config[k];
//                    }
//                }
//            }
//        }
//        return object;
//    },

//    /**
//     * 
//     * @param {any} ns_string
//     * @deprecated
//     */
//    namespace: function (ns_string) {
//        let parts = ns_string.split('.'), parent = SPIRIT, i;

//        if (parts[0] === 'SPIRIT') {
//            parts = parts.slice(1);
//        }

//        for (i = 0; i < parts.length; i += 1) {
//            if (typeof parent[parts[i]] === 'undefined') {
//                parent[parts[i]] = {};
//            }
//            parent = parent[parts[i]];
//        }
//        return parent;
//    },


//    /**
//     * TODO
//     * このままだと、
//     * Loadingクラスがシングルトンではないため、
//     * SPRITをモジュールをimportしているところで
//     * 各々インスタンスを作成してし待っている.
//     * よって2重でかかることも想定される
//     */
//    loading: {
//        show: loading.show,
//        hide: loading.hide,
//    },

//    util: Util,
//    business: Business,
//    session: Session,
//    dialog: Dialog,
//    notify: Notify,
//    /***/
//    base: {
//        ModalBase: ModalBase,
//        PageBase: PageBase,
//    },

//    //define: {
//    //    codeValues: CodeValues,
//    //    //enums: Enums
//    //},

//    codes: Codes,

//    //↓なんか駄目らしい
//    //enums: Enums

//};

////export = SPIRIT;

